<!-- 新增商品第三步 -->
<template>
  <div>
    <div class="step-container">
      <eui-steps :active="active" :data="stepData"></eui-steps>
    </div>
    <div class="container">
      <div class="title">
        <span>基本信息</span>
      </div>
      <div class="info-content">
        <!-- <div class="info-form">
          <el-row>
            <el-col :span="12">
              <span class="item-name">所属分类：</span>
              <span class="item-info">{{ category }}</span>
            </el-col>
          </el-row>
        </div> -->
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="所属分类:">
            <span class="item-info">{{ category }}</span></el-form-item
          >
          <el-row>
            <el-col :span="12">
              <el-form-item label="商品名称:" prop="skuName">
                <el-input
                  v-model="ruleForm.skuName"
                  placeholder="请输入商品名称"
                ></el-input>
                <!-- <span class="item-info">{{ ruleForm.skuName }}</span> -->
              </el-form-item>
            </el-col></el-row
          >

          <el-form-item label="商品图片:" prop="productImg">
            <addIamge
              v-if="imageUrls.length > 0"
              :show-file-list="imageUrls"
              @getImgList="handleProductImgList"
            ></addIamge>
          </el-form-item>

          <el-form-item label="供货周期:" prop="leadTime">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="ruleForm.leadTime"
                  placeholder="示例：10-20天"
                ></el-input>
              </el-col>
              <el-col :span="1">
                <span class="unit-txt">天</span>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="产品特色:" prop="uniqueFeature">
            <el-input
              v-model="ruleForm.uniqueFeature"
              type="textarea"
              placeholder="请输入产品特色"
              maxlength="300"
              show-word-limit
            ></el-input>
          </el-form-item>
          <div class="property-wrap">
            <div class="property-title">商品属性参数范围</div>
            <el-row>
              <el-col
                v-for="(item, index) in ruleForm.attributes"
                :key="item.attributeId"
                :span="12"
              >
                <el-form-item
                  :label="item.attributeName + ':'"
                  :prop="'attributes.' + index + '.attributeValue'"
                  :rules="{
                    required: true,
                    message: '商品属性参数值不能为空',
                    trigger: 'blur',
                  }"
                >
                  <el-input
                    v-model="item.attributeValue"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="压力:" prop="date">
                  <el-input
                    v-model="ruleForm.date"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="材质:" prop="date">
                  <el-input
                    v-model="ruleForm.date"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col> -->
            </el-row>
            <!-- <el-row>
              <el-col :span="12">
                <el-form-item label="材质:" prop="date">
                  <el-input
                    v-model="ruleForm.date"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
          </div>
          <div class="property-wrap">
            <div class="property-title">商品详情</div>
            <el-form-item label="结构图纸:" prop="structureImg">
              <addIamge
                v-if="constructionImageUrls.length > 0"
                :show-file-list="constructionImageUrls"
                @getImgList="handleStructureImgList"
              ></addIamge>
            </el-form-item>
            <el-form-item label="性能参数:" prop="parameterImg">
              <addIamge
                v-if="propertyImageUrls.length > 0"
                :show-file-list="propertyImageUrls"
                @getImgList="handleParameterImgList"
              ></addIamge>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="btn-box">
      <eui-btn type="secondary" @click="goPre">取消</eui-btn>
      <eui-btn type="primary" @click="submitTable('submit')">确定</eui-btn>
      <!-- <div class="btn-wrap">
        <eui-btn type="primary" @click="submitTable('save')">继续添加</eui-btn>
        <eui-btn type="primary" @click="submitTable('submit')"
          >提交审核</eui-btn
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import Bus from '@/components/common/bus.js';
import addIamge from '../../../components/product/productManage/offstandardProductAddImg.vue';
import api from '../../../api/product/index.js';

export default {
  components: { addIamge },
  data() {
    const validateProductImgList = (rule, value, callback) => {
      if (this.ruleForm.imageUrls.length === 0) {
        callback(new Error('请上传商品图片'));
      } else {
        callback();
      }
    };
    const validateStructureImgList = (rule, value, callback) => {
      if (this.ruleForm.constructionImageUrls.length === 0) {
        callback(new Error('请上传结构图纸图片'));
      } else {
        callback();
      }
    };
    const validateParameterImgList = (rule, value, callback) => {
      if (this.ruleForm.propertyImageUrls.length === 0) {
        callback(new Error('请上传性能参数图片'));
      } else {
        callback();
      }
    };
    return {
      active: 2,
      fristCategry: ['动力轴', '动力轴', '动力轴', '动力轴', '动力轴'],
      productInfo: {},
      category: '',
      ruleForm: {
        skuName: '',
        imageUrls: [], // 商品图片
        uniqueFeature: '', // 唯一特征
        leadTime: '', // 供货周期
        constructionImageUrls: [], // 结构图片
        propertyImageUrls: [], // 属性图片
        attributes: [],
      },
      constructionImageUrls: [],
      propertyImageUrls: [],
      imageUrls: [],
      rules: {
        skuName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          {
            min: 1,
            max: 300,
            message: '长度在 1 到 300 个字符',
            trigger: 'blur',
          },
        ],

        uniqueFeature: [
          {
            required: true,
            message: '请选择日期',
            trigger: 'change',
          },
        ],
        leadTime: [
          {
            required: true,
            message: '请输入供货周期',
            trigger: 'blur',
          },
          {
            min: 1,
            max: 10,
            message: '长度在 1 到 10 个字符',
            trigger: 'blur',
          },
        ],
        productImg: [
          {
            required: true,
            validator: validateProductImgList,
            trigger: 'change',
          },
        ],
        structureImg: [
          {
            required: true,
            validator: validateStructureImgList,
            trigger: 'change',
          },
        ],
        parameterImg: [
          {
            required: true,
            validator: validateParameterImgList,
            trigger: 'change',
          },
        ],
      },
      stepData: [
        {
          title: '选择分类',
          // tip:'这里是提示文字',
          // description:'这里是多行描述文字',
          // icon:''
        },
        {
          title: '编辑商品基本信息',
          // tip:'这里是提示文字',
          // description:'这里是多行描述文字',
          // icon:''
        },
        {
          title: '编辑商品详情信息',
          // tip:'这里是提示文字',
          // description:'这里是多行描述文字',
          // icon:''
        },
        {
          title: '提交审核',
          // tip:'这里是提示文字',
          // description:'这里是多行描述文字',
          // icon:''
        },
        {
          title: '发布完成',
          // tip:'这里是提示文字',
          // description:'这里是多行描述文字',
          // icon:''
        },
      ],
      auditStatus: null,
    };
  },
  computed: {},
  activated() {
    const newCategory = this.$getStore('categoryName');
    if (newCategory != this.category) {
      this.category = newCategory;
      this.productInfo = this.$store.state.productList;
      this.tableData = this.$store.state.categoryList;
    }
  },

  created() {
    this.productInfo = this.$store.state.productList;
    this.tableData = this.$store.state.categoryList;
    this.category = this.$getStore('categoryName');
    // this.getPropertyListInTable();
    const { skuId, auditStatus, productAuditId } = this.$route.query;
    this.auditStatus = auditStatus;
    const id = auditStatus !== undefined ? productAuditId : skuId;
    this.getProductDetail(id);
    console.log('父组件');
  },
  methods: {
    // 获取商品详情
    async getProductDetail(id) {
      let res = null;
      if (this.auditStatus !== null && this.auditStatus === '104') {
        res = await api.getCompanyOffStandardSkuInfoWithAudit({
          productAuditId: id,
        });
      } else {
        res = await api.getCompanyOffStandardSkuInfo({
          skuId: id,
        });
      }

      if (res.code === '200') {
        if (this.auditStatus !== null && this.auditStatus === '104') {
          this.productInfo = res.data;
          this.ruleForm = res.data.productVO.skus[0];
        } else {
          this.productInfo = res.data;
          this.ruleForm = res.data.skus[0];
        }

        this.constructionImageUrls = this.assembleShowImgList(
          this.ruleForm.constructionImageUrls
        );

        this.propertyImageUrls = this.assembleShowImgList(
          this.ruleForm.propertyImageUrls
        );
        this.imageUrls = this.assembleShowImgList(this.ruleForm.imageUrls);
        console.log(this.constructionImageUrls);
      } else {
        this.$message.error(res.message);
      }
    },
    // 组装回显图片数据
    assembleShowImgList(imgArr) {
      const constructionImageUrls = [];

      for (let i = 0; i < imgArr.length; i++) {
        constructionImageUrls.push({ url: imgArr[i] });
      }
      return constructionImageUrls;
    },
    goPre() {
      this.$router.go(-1);
    },
    // 获取规格列表
    async getPropertyListInTable() {
      const res = await api.getPropertyByCategory({
        categoryId: this.$store.state.productList.categoryId,
        attributeType: 1,
      });
      if (res.code === '200') {
        // this.standardList = res.data;
        this.ruleForm.attributes = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    submitTable() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let data = {};
          data.taxRateValue = parseFloat(data.taxRateValue);

          console.log(data);
          data.salesScope = Number(data.salesScope);

          let res = null;
          if (this.auditStatus !== null && this.auditStatus === '104') {
            console.log(this.productInfo);
            data.productAO = this.productInfo.productVO;
            data.productAuditId = this.productInfo.productAuditId;
            res = await api.submitOffstandardProductWithAudit(data);
          } else {
            // data.skus = this.assemblyOneSubmitData(this.ruleForm);
            data = this.productInfo;
            res = await api.submitOffstandardProductWithEdit(data);
          }

          if (res.code === '200') {
            this.$message.success(
              '提交成功，可在商品维护列表查看商品审核进度。'
            );
            this.$router.push({ path: '/createProduct' });
            console.log(res);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
        return true;
      });
    },
    // 组装单条新增数据
    assemblyOneSubmitData(obj) {
      const temArr = [];
      // for (let i = 0; i < arr.length; i++) {
      const temObj = {};
      temObj.imageUrls = obj.imageUrls ? obj.imageUrls : [];
      temObj.leadTime = obj.leadTime ? obj.leadTime : '';
      temObj.defaultImage = obj.imageUrls.length > 0 ? obj.imageUrls[0] : '';
      temObj.skuName = obj.skuName.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
      temObj.attributes = [];
      temObj.attributeStr = '';
      temObj.constructionImageUrls = obj.constructionImageUrls
        ? obj.constructionImageUrls
        : [];
      temObj.propertyImageUrls = obj.propertyImageUrls
        ? obj.propertyImageUrls
        : [];
      temObj.uniqueFeature = obj.uniqueFeature ? obj.uniqueFeature : '';
      temObj.attributes = obj.attributes ? obj.attributes : [];
      // temObj.id = obj.id;
      // for (const key in arr[i]) {
      //   if (util.isObject(arr[i])) {
      //     if (arr[i][key].isStandard == true) {
      //       temObj.attributes.push(arr[i][key]);
      //       temObj.attributeStr += this.assemblyOneDataStandardStr(
      //         arr[i][key]
      //       );
      //     }
      //   }
      // }
      temArr.push(temObj);
      // }
      return temArr;
    },
    // 组装单条数据的规格字符串
    assemblyOneDataStandardStr(obj) {
      const str =
        obj.beforeSymbol +
        // obj.attributeName +
        obj.attributeValue +
        obj.unitValue +
        obj.behindSymbol +
        obj.connectSymbol;
      return str;
    },
    // 获取商品图
    handleProductImgList(val) {
      console.log(val);
      this.ruleForm.imageUrls = this.assembleImg(val);
    },
    // 获取结构图
    handleStructureImgList(val) {
      console.log(val);
      this.ruleForm.constructionImageUrls = this.assembleImg(val);
    },
    // 获取性能参数图
    handleParameterImgList(val) {
      this.ruleForm.propertyImageUrls = this.assembleImg(val);
    },
    // 组装图片参数
    assembleImg(arr) {
      const imgArr = [];
      if (arr.length === 0) {
        return false;
      }
      arr.forEach((item) => {
        imgArr.push(item.url);
      });
      return imgArr;
    },
  },
};
</script>
<style lang="scss" scoped>
.step-container {
  margin-bottom: 10px;
}
.container {
  .title {
    margin-top: 10px;
    // border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;
    line-height: 1;
    margin-bottom: 10px;
    span {
      font-size: 16px;
      color: #333;
    }
  }
}
.sort-content {
  padding: 0 30px;
  .sort-search {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
}
.btn-box {
  display: flex;
  margin-top: 20px;
  justify-content: center;
}
.info-form {
  padding: 17px 0;
  .item-name {
    margin-bottom: 30px;
    color: #999;
    font-size: 14px;
  }
  .item-info {
    color: #000;
    font-size: 14px;
  }
}
.info-table {
  .head-title {
    color: #333;
    font-size: 14px;
  }
}
.unit-txt {
  margin-left: 10px;
  flex-shrink: 0;
}
.property-wrap {
  .property-title {
    height: 40px;
    // line-height: 40px;
    background: #f5f5f5;
    font-size: 14px;
    color: #333;
    font-weight: 500;
    padding: 13px 20px;
    margin-bottom: 10px;
    line-height: 1;
  }
}
</style>
